import React, { Component } from "react";
import ResultItem from "./ResultItem";
import debounce from "lodash/debounce";
import { SchemasApi } from "@solarschools/api-sdk";
import onClickOutside from "react-onclickoutside";
import { client } from "../hooks/useDataResource/useDataResource";

class SchoolSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      schools: [],
      searchTerm: "",
    };

    this.fetchSchools = this.fetchSchools.bind(this);
    this.setFocus = this.setFocus.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.unsetFocus = this.unsetFocus.bind(this);
    this.handleTextChanged = this.handleTextChanged.bind(this);
  }

  clearForm() {
    this.setState({ searchTerm: "" });
    this.unsetFocus();
  }

  setFocus() {
    this.setState({ active: true });
  }

  unsetFocus() {
    this.setState({ active: false });
  }

  handleClickOutside(event) {
    this.unsetFocus();
  }

  async fetchSchools(query = false) {
    // use thew siutes PAI to search for schools here
    const solarSchools = new SchemasApi(client());
    const { results } = await solarSchools.searchResources(1, query, {
      limit: 5,
      // resourceMode: 'mixed',
      resourceMode: "organisations",
      extendedDetails: true,
      stats: true,
      weather: true,
    });
    this.setState({
      schools: results,
    });
  }

  handleTextChanged(e) {
    this.setState({ searchTerm: e.target.value });
    debounce(this.fetchSchools, 500)(e.target.value);
  }

  render() {
    return (
      <span>
        <div
          className={`input-group h-100 border-0 rounded-0 ${
            this.state.active ? "bg-primary-faded" : "bg-primary"
          } text-white`}
        >
          <div className="input-group-prepend my-auto pl-2">
            <span className="fa fa-map-marker" />
          </div>
          <input
            type="text"
            id="school-search"
            className={`h-100 border-0 rounded-0 px-2 ml-1 ${
              this.state.active ? "bg-primary-faded" : "bg-primary"
            } text-white`}
            style={{ outline: 0 }}
            onChange={this.handleTextChanged}
            onFocus={this.setFocus}
            // onBlur={this.unsetFocus}
            placeholder="Find a school by name"
            value={this.state.searchTerm}
            tabIndex={2}
          />
          {this.state.searchTerm !== "" ? (
            <div
              onClick={this.clearForm}
              className="input-group-append my-auto px-2 btn"
            >
              <i className="fa fa-fw fa-times-circle" />
            </div>
          ) : null}
        </div>
        {this.state.active && this.state.schools.length > 0 ? (
          this.state.schools.length > 0 && this.state.searchTerm !== "" ? (
            <ul
              tabIndex={0}
              className="list-group position-absolute layer-overlay col-11 col-md-6 shadow-sm p-0"
            >
              {this.state.schools.map((school, index) => {
                const {
                  resourceType,
                  resourceId,
                  resourceName,
                  slug,
                  country = null,
                  state = null,
                  childCount = null,
                  peakSolarCapacity = null,
                  temperature = null,
                  weatherIcon = null,
                } = school;
                return (
                  <ResultItem
                    resourceType={resourceType}
                    resourceId={resourceId}
                    resourceName={resourceName}
                    slug={slug}
                    country={country}
                    state={state}
                    weatherIcon={weatherIcon}
                    temperature={temperature}
                    capacity={peakSolarCapacity}
                    siteCount={childCount}
                    tabIndex={2}
                    key={index}
                  />
                );
              })}
            </ul>
          ) : null
        ) : null}
      </span>
    );
  }
}

export default onClickOutside(SchoolSearch);



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolSearch/index.js